import { createSelector } from "@reduxjs/toolkit";
import { getBaseLang } from "@nxplatform/helpers/helpers-pure";
const getImagePathByLocale = (allowedLocations) => {
  const lang = getBaseLang();
  return allowedLocations.includes(lang) ? `${lang}/` : "";
};
const allowedToSwitch = ["png", "jpg", "jpeg", "webp"];
const generateWebpPath = createSelector(
  (params) => params,
  (params) => {
    if (!params.path || typeof params.path !== "string") {
      return "";
    }
    const pathAndParams = params.path.split("?");
    const [fileExt] = pathAndParams[0].split(".").slice(-1);
    const paramsPart = pathAndParams.length > 1 && pathAndParams[1] ? `?${pathAndParams[1]}` : "";
    return params.webpSupport && allowedToSwitch.includes(fileExt.toLowerCase()) ? `${pathAndParams[0].substr(
      0,
      pathAndParams[0].lastIndexOf(".")
    )}.webp${paramsPart}` : params.path;
  }
);
export {
  generateWebpPath,
  getImagePathByLocale
};
